import { FC, useEffect } from "react";
import { Helmet } from "react-helmet";
import { fetchAsync } from "../../services/ApiHandler";
import { PromptHintSet } from "../../model/PromptHintSet";

export const CardRegisteredPage: FC = () => {
  useEffect(() => {
    const updateCardInfo = async () => {
      await fetchAsync<PromptHintSet[]>('Stripe/UpdateCardInfo');
    };
    updateCardInfo();
  }, []);

  return <>
    <Helmet>
      <title>クレジットカード登録完了</title>
      <meta name="description" content="クレジットカード登録完了" />
    </Helmet>
      <div className="mt-4 text-base sm:text-lg font-bold">クレジットカード情報の登録が完了しました！</div>
  </>;
}